import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "../styles/Navbar.css";


function Navbar() {

const [menuOpen,setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">

        <div className="logo">
  <Link to="/">
    <img src="./logo.png" alt="Onsite Interiors" className="logo-img"/>
  </Link>
</div>

        <div className="menu-icon" onClick={()=>setMenuOpen(!menuOpen)}>
          ☰
        </div>

    <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>

        <li>
          <NavLink to="/" onClick={()=>setMenuOpen(false)}>Home</NavLink>
        </li>

        <li>
          <NavLink to="/about" onClick={()=>setMenuOpen(false)}>About Us</NavLink>
        </li>

        <li>
          <NavLink to="/projects" onClick={()=>setMenuOpen(false)}>Our Projects</NavLink>
        </li>

        <li>
          <NavLink to="/designs" onClick={()=>setMenuOpen(false)}>Designs</NavLink>
       </li>

       <li>
          <NavLink to="/contact" onClick={()=>setMenuOpen(false)}>Contact Us</NavLink>
       </li>

     </ul>

        <div className="nav-button">
          <a
            href="https://wa.me/916280289442"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>Get Free Quote</button>
          </a>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;